import React from 'react';
import { Link } from 'react-router';
import Card from 'components/Card';
import { ResourceCardElement } from 'components/ResourceCardElements';
import styles from 'styles/resourceCard';
import StoreType from 'types/store';

const StoreCard = ({ store }) =>
  <Link className={styles.viewLink} to={`/stores/${store.id}`}>
    <Card key={store.id} className={styles.resourceCard}>
      <ResourceCardElement title="Store Number" size="small" value={store.number} />
      <ResourceCardElement title="Store Name" size="small" value={store.name} />
      <ResourceCardElement title="Phone Number" size="small" value={store.phone_number} />
      <ResourceCardElement title="Workroom" size="small" value={store.workroom_name || 'No Workroom'} />
      <ResourceCardElement title="ISO/IST"size="small" value={store.cpo_iso} />
    </Card>
  </Link>;

StoreCard.propTypes = {
  store: StoreType.isRequired,
};

export default StoreCard;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/stores/components/storeCard.jsx